import theme from "../theme";

export const mobileMedia = `@media screen and (max-width: ${theme.breakpoints.sm})`;
